import React from 'react';
import cn from 'classnames';
import "./BreadcrumbList.css";
var styles = { "list": "aa23f4", "center": "f34923", "left": "e69824", "right": "fa88c5", "item": "c8f123", "active": "c28c8a", "highlightItem": "b7f042", "capitalizeText": "d4523d", "separator-narrow": "a67e13", "separator-wide": "c53d63", "item-northstar": "eff749" };
import BreadcrumbLink from '../BreadcrumbLink';
import Separator from '../Separator';
const BreadcrumbList = ({ variant = 'hm', links, shouldCapitalizeText, spacing = 'narrow', separator, onItemClick, shouldHighlightLastItem, alignment, }) => {
    const lastLinkIndex = links.length - 1;
    const trackingLabelArray = links.map((el) => {
        return el.trackingLabel || el.label || null;
    });
    const eventLabel = trackingLabelArray.join('/');
    return (React.createElement("ol", { className: cn(styles.list, alignment && styles[alignment]) }, links.map(({ label, href, isClickable, Tag, customProps }, index) => {
        // is if it react element link
        const isCustomLinkElement = !!Tag && !!customProps;
        const isCurrentPage = index === lastLinkIndex;
        // hm-react can send label as Label element, TODO: tobe fixed
        const isLabelString = typeof label === 'string';
        const previousItem = links === null || links === void 0 ? void 0 : links[index - 1];
        const isFirstItem = index === 0;
        // default the item to clickable if not set as false by aem
        const isCurrentItemClickable = typeof isClickable === 'undefined' || isClickable;
        const isPreviousItemClickable = previousItem &&
            (typeof previousItem.isClickable === 'undefined' || previousItem.isClickable);
        let text = '';
        if (isLabelString) {
            if (!isPreviousItemClickable && !isFirstItem) {
                text = `${previousItem === null || previousItem === void 0 ? void 0 : previousItem.label} ${label}`;
            }
            else {
                text = label;
            }
        }
        const shouldRenderElement = isCustomLinkElement || (href && isCurrentItemClickable) || isCurrentPage;
        return (shouldRenderElement && (React.createElement("li", { key: isLabelString ? text : href, className: cn(styles.item, styles[`item-${variant}`], isCurrentPage && styles.active, shouldHighlightLastItem && styles.highlightItem) },
            React.createElement(BreadcrumbLink, { variant: variant, onItemClick: onItemClick, isCurrentPage: isCurrentPage, shouldCapitalizeText: shouldCapitalizeText, Tag: Tag, customProps: customProps, eventLabel: eventLabel, href: href, additionalClass: cn(shouldCapitalizeText && styles.capitalizeText) }, isLabelString ? text : label),
            React.createElement(Separator, { isCurrentPage: isCurrentPage, className: cn(spacing && styles[`separator-${spacing}`]), separator: separator }))));
    })));
};
export default BreadcrumbList;
//# sourceMappingURL=BreadcrumbList.js.map